import { localizable } from 'components/Localization';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import React, { Component, Fragment } from 'react';

@localizable
@observer
class BehalfOfAgentsDropdown extends Component {
  @observable selectedAgent = {};

  agentOfficeName = (agent) => {
    return (
      (agent.office ? agent.office.friendly_name : undefined) ||
      agent.agency_friendly_name ||
      (agent.office ? agent.office.name : undefined) ||
      agent.agency_name
    );
  };

  componentDidMount() {
    const { selectedAgent } = this.props;
    this.selectedAgent = selectedAgent;
  }

  agentKey = (agent) => {
    if (!agent) return;
    const office =
      (!agent.office ? undefined : agent.office.name) || agent.office_id;
    return office ? `${agent.sub}---${office}` : agent.sub;
  };

  agentDisplayName = (agent) => {
    const office = this.agentOfficeName(agent);
    return `${agent.name}${office ? ` (${office})` : ''}`;
  };

  handleAgentChanged = (e) => {
    const { onAgentChanged, agents } = this.props;
    if (!onAgentChanged) return;

    const agent = agents.find((a) => this.agentKey(a) === e.key);
    this.selectedAgent = agent;
    onAgentChanged(agent);
  };

  render() {
    const { t, selectedAgent, agents } = this.props;
    const selectedAgentKey = this.agentKey(selectedAgent);

    return (
      <Fragment>
        <Dropdown
          label={t('Behalf of')}
          selectedKey={selectedAgentKey}
          onChanged={this.handleAgentChanged}
          options={agents.map((agent) => {
            return {
              key: this.agentKey(agent),
              text: this.agentDisplayName(agent),
            };
          })}
          required={true}
        />

        {!!this.selectedAgent && this.selectedAgent.name && (
          <Fragment>
            <p>
              {this.selectedAgent.agency_name && (
                <div>{this.selectedAgent.agency_name}</div>
              )}
              {this.selectedAgent.email && (
                <div>
                  {t('email')}: {this.selectedAgent.email}
                </div>
              )}
              {this.selectedAgent.phone_number && (
                <div>
                  {t('phone_number')}: {this.selectedAgent.phone_number}
                </div>
              )}
            </p>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default BehalfOfAgentsDropdown;



// WEBPACK FOOTER //
// ./src/app/components/BehalfOfAgentsDropdown/index.jsx